import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a484c73e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-20 w-100" }
const _hoisted_2 = { class: "contribution-table bordered-card w-100" }
const _hoisted_3 = { class: "bordered-card width-30 w-sm-100 height-100" }
const _hoisted_4 = { class: "d-flex align-items-end gap-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Days Worked", -1))
const _hoisted_6 = { class: "tooltip-wrapper d-flex align-items-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }, null, -1))
const _hoisted_8 = { class: "tooltip-text tooltip-text_secondary tooltip-text__large" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "contribution-left-table navigator" }
const _hoisted_11 = { class: "vertical-carousel" }
const _hoisted_12 = { class: "vertical-carousel__controls" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-solid vertical-carousel__arrow" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-solid vertical-carousel__arrow icon-rotate-180" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "vertical-carousel__slides" }
const _hoisted_20 = { class: "contribution-left-lines" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "sm-ml-0 sm-fs-sm" }
const _hoisted_23 = { class: "sm-fs-sm sm-pdr-0" }
const _hoisted_24 = { class: "contribution-left-line" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "sm-fs-sm" }, " Total Days Accumulated ", -1))
const _hoisted_26 = { class: "sm-fs-sm" }
const _hoisted_27 = { class: "contributions-tables" }
const _hoisted_28 = { class: "contributions-tables-header" }
const _hoisted_29 = { class: "label label_blue" }
const _hoisted_30 = { class: "contributions-table-wrapper" }
const _hoisted_31 = { class: "contributions-table-item no-striped" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " Contribution Detail ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Receipt Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Work Period Ending"),
    /*#__PURE__*/_createElementVNode("th", null, "Employer"),
    /*#__PURE__*/_createElementVNode("th", null, "Production"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit")
  ])
], -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, "No contributions found.")
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "plan-summary__footer d-flex flex-md-row flex-column gap-10 w-100" }
const _hoisted_39 = { class: "col-12 col-md-4 d-flex flex-column justify-content-between gap-10" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Other Coverages", -1))
const _hoisted_41 = { class: "account-actions sm-pdb-10" }
const _hoisted_42 = { class: "col-12 col-md-8" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Account Actions", -1))
const _hoisted_44 = { class: "action-buttons mt-10 flex-md-row flex-column sm-pdl-0 sm-pdr-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OtherCoverages = _resolveComponent("OtherCoverages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(" Click on contribution period in this “Coverage” column to see the associated work month in the “Days Worked” column. Click the up/down arrows to change the range of work months and the coverage period. Click the work month to see corresponding contributions. "),
              _hoisted_9,
              _createTextVNode(" For Plan A Coverage Eligibility/Qualification, refer to "),
              _createElementVNode("a", {
                class: "text-white",
                href: "javascript:void(0)",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPDF && _ctx.openPDF(...args)))
              }, " Summary Plan Description ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevItem && _ctx.prevItem(...args))),
                class: _normalizeClass({ 'disabled-button': _ctx.prevDisabled }),
                disabled: _ctx.prevDisabled
              }, _hoisted_15, 10, _hoisted_13),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextItem && _ctx.nextItem(...args))),
                class: _normalizeClass({ 'disabled-button': _ctx.nextDisabled }),
                disabled: _ctx.nextDisabled
              }, _hoisted_18, 10, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_TransitionGroup, {
                  name: "fade",
                  tag: "div"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.date,
                        class: _normalizeClass(["contribution-left-line", { current: _ctx.selectedIndex === index }]),
                        onClick: ($event: any) => (_ctx.selectItem(index))
                      }, [
                        _createElementVNode("h5", _hoisted_22, _toDisplayString(item.displayDate), 1),
                        _createElementVNode("h5", _hoisted_23, _toDisplayString(item.daysWorked), 1)
                      ], 10, _hoisted_21))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("h5", _hoisted_26, _toDisplayString(_ctx.totalVisibleDays), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h4", null, " For Coverage: " + _toDisplayString(_ctx.currentCoveragePeriod), 1),
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.eligibilityStatus), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("table", null, [
              _hoisted_33,
              (_ctx.currentContributions.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentContributions, (contribution) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: contribution.ParticipantWHID
                      }, [
                        _createElementVNode("td", null, _toDisplayString(contribution.TranProcDate), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.PeriodEnd), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.EmployerName), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.ProductionName), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.DaysWorked), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_35, _hoisted_37))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_OtherCoverages, { otherCoverages: _ctx.otherCoverages }, null, 8, ["otherCoverages"])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary plan-modal",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('add-beneficiary', 'My Beneficiary(ies)', 'plan-tables-striped beneficiary', null, null, null
                        )), ["prevent"]))
          }, " Beneficiary(ies) "),
          (_ctx.isAvailableForClaim)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "btn btn-secondary btn-large plan-modal",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openModal('claims', 'Claims', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
              }, " Claims "))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openModal('request-card', 'Request for Insurance ID Card(s)', 'plan-upload plan-card-info plan-profile-update')), ["prevent"])),
            class: "btn btn-secondary"
          }, "Request ID Card(s)"),
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openModal('dependents', 'My Dependents', null)), ["prevent"]))
          }, "My Dependents ")
        ])
      ])
    ])
  ]))
}